export default __webpack_public_path__ + "8887ec9321d25c1346a4ef2eee223666.svg";